export enum FunctionType {
  AddSubscriptions = 'AddSubscriptions',
  EndSubscriptions = 'EndSubscriptions',
  DeactivateParker = 'DeactivateParker',
  ActivateParker = 'ActivateParker',
  UnlinkParker = 'UnlinkParker',
  ResendLink = 'ResendLink',
  ReplaceSubscription = 'ReplaceSubscription',
  RecalculateParkingSessions = 'RecalculateParkingSessions',
  AdjustSubscriptions = 'AdjustSubscriptions',
  AddSubscriptionSet = 'AddSubscriptionSet',
}
